import React from 'react';
import axios from "../../containers/api";
import {Modal, ModalHeader, ModalBody, ModalFooter, Button} from "reactstrap";
import {toCurrency} from "../../helpers/Utils";
import Num2persian from 'num2persian';

class PrintDriverReserve extends React.Component {
    state = {
        dataList: [],
        showModal: false,
        stimulsoftLoaded: sessionStorage.getItem("stimulsoftLoaded") === "true"
    };

    componentDidMount() {
        if (!this.state.stimulsoftLoaded) {
            this.loadStimulSoftFiles();
        }
        this.props.onRef(this);
    }

    loadStimulSoftFiles = () => {
        const script = document.createElement("script");
        script.src = "/scripts/stimulsoft.js";
        script.onload = () => {
            sessionStorage.setItem("stimulsoftLoaded", "true");
        };
        document.body.appendChild(script);
    };

    componentWillUnmount() {
        this.props.onRef(undefined);
    }

    Report_DriverReserve = (id) => {
        this.props.showSpinner();
        axios.get('/api/v1/driver-reservations/Report_DriverReserve?Id=' + id)
            .then((res) => {
                this.props.hideSpinner();
                console.log(res.data);
                if (res.data.data === null) {
                    this.props.showAlert("هیچ اطلاعاتی موجود نیست", "warning");
                } else {
                    this.props.showAlert("فراخوانی اطلاعات کامل شد", "success");
                    this.setState({showModal: true});
                    this.prepare(res.data.data);
                }
            })
            .catch((error) => {
                if (error.response) {
                    console.log("status: " + error.response.status);
                    console.log("message: " + error.response.data.message);
                    this.props.showAlert("خطای ارتباطی " + error.response.status, "error");
                } else {
                    this.props.showAlert("خطای نامشخص " + error.message, "error");
                }
            });
    };

    changeComponentValue = (report, componentName, newValue) => {
        let component = report.getComponentByName(componentName);
        if (component === null || component === undefined) {
            return;
        }
        component['_text'] = newValue;
    };

    prepare = (Reserve) => {
        let ReserveReport = Reserve;
        if (ReserveReport == null) {
            return;
        }

        let viewer = new window.Stimulsoft.Viewer.StiViewer(null, 'StiViewer', false);
        let report = new window.Stimulsoft.Report.StiReport();

        window.Stimulsoft.Base.StiLicense.loadFromFile("/reports/license.key");

        report.loadFile('/reports/DriverReserveReport.mrt');
       
        this.changeComponentValue(report, 'Text_ReserveDate', '' + (Reserve.reserveDate));
        this.changeComponentValue(report, 'Text_DriverReserveId', '' + (Reserve.id));
        this.changeComponentValue(report, 'Text_CargoSource', '' + (Reserve.cargoSource));
        this.changeComponentValue(report, 'Text_CargoDestination', '' + (Reserve.cargoDestination));

       
        this.changeComponentValue(report, 'Text_DriverFullName', '' + Reserve.driverName + ' ' + Reserve.driverFamily);
        this.changeComponentValue(report, 'Text_DriverCardNumber', '' + Reserve.driverCardNumber);
        this.changeComponentValue(report, 'Text_NationalId', '' + (Reserve.nationalId));
        this.changeComponentValue(report, 'Text_DriverMobile', '' + (Reserve.mobile));
        this.changeComponentValue(report, 'Text_LoaderTypeName', '' + Reserve.loaderTypeName);
        this.changeComponentValue(report, 'Text_PlaqueNumber', '' + Reserve.plaqueNumber);
        this.changeComponentValue(report, 'Text_PlaqueSerialNumber', '' + (Reserve.plaqueSerialNumber));
        this.changeComponentValue(report, 'Text_FreighterCardNumber', '' + (Reserve.freighterCardNumber));
        this.changeComponentValue(report, 'Text_KalaDesc', '' + (Reserve.kalaDesc));
        this.changeComponentValue(report, 'Text_BastebandyNumber', '' + (Reserve.bastebandyNumber)); 
        this.changeComponentValue(report, 'Text_KalaValue', '' + (Reserve.kalaValue));
        this.changeComponentValue(report, 'Text_BastebandyName', '' + (Reserve.bastebandyName));
        this.changeComponentValue(report, 'Text_Description', '' + (Reserve.description));
        this.changeComponentValue(report, 'txt_rent', '' + toCurrency(Reserve.driverReserveCargoRent));
        

          
          

        viewer.report = report;
        viewer.renderHtml('viewer');
    };

    closeModal = (modalName) => {
        this.setState({ [modalName]: false });
    };

    render() {
        return (
            <>
                <Modal isOpen={this.state.showModal} toggle={() => this.closeModal("showModal")} size="xlg">
                    <ModalHeader toggle={() => this.closeModal("showModal")}>
                        چاپ
                    </ModalHeader>
                    <ModalBody>
                        <div className="print-draft">
                            <div id="viewer"/>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={() => this.closeModal("showModal")}>
                            انصراف
                        </Button>
                    </ModalFooter>
                </Modal>
            </>
        )
    }
}

export default PrintDriverReserve;
